import { Event } from "../types/domain.ts";
import {isAirportsEvent} from "./eventGuards.ts";
import dayjs from "dayjs";

export const getEventTime = (event: Event) => {
    const startTimes = isAirportsEvent(event) ?
        event.airports.map(({ from }) => from) :
        [
            ...event.departures.map(({ from }) => from),
            ...event.arrivals.map(({ from }) => from),
        ];
    const endTimes = isAirportsEvent(event) ?
        event.airports.map(({ to }) => to) :
        [
            ...event.departures.map(({ to }) => to),
            ...event.arrivals.map(({ to }) => to),
        ];

    const earliestStart = startTimes.length ? startTimes.reduce((earliest, current) =>
        dayjs(current, 'HH:mm').isBefore(dayjs(earliest, 'HH:mm')) ? current : earliest
    ) : null;

    const latestEnd = endTimes.length ? endTimes.reduce((latest, current) =>
        dayjs(current, 'HH:mm').isAfter(dayjs(latest, 'HH:mm')) ? current : latest
    ) : null;

    return [earliestStart ? dayjs.utc(earliestStart, 'HH:mm') : null, latestEnd ? dayjs.utc(latestEnd, 'HH:mm') : null];
}